export default __webpack_public_path__ + "static/media/lungeRun.8922e541.png";